import request from '@/utils/request';

export function getSupervisionList(params) {
  return request({
    url: '/controle_internes/supervision',
    method: 'get',
    params,
  });
}

export function getControleInterneDetails(id) {
  return request({
    url: `/controle_internes/${id}`,
    method: 'get',
    params: { details: 1 },
  });
}

export function approuverSuperviseur(id, data) {
  return request({
    url: `/controle_internes/${id}/approbation-superviseur`,
    method: 'post',
    data,
  });
}
